import type { CSSProperties } from "react";

export const SELECTED_CARD_STYLE: CSSProperties = {
  background:
    "linear-gradient(to bottom right, color-mix(in srgb, var(--color-primary-50) 40%, white), color-mix(in srgb, var(--color-secondary-50) 40%, white)) padding-box, linear-gradient(to bottom right, color-mix(in srgb, var(--color-primary-400) 70%, transparent), color-mix(in srgb, var(--color-secondary-400) 70%, transparent)) border-box",
};
